declare namespace $ {

	export class $shm_hitalama_components_source extends $shm_textarea_code {
		definition( ): $shm_hitalama_map_widget_entity_custom
		kind( ): string
		failure( ): string
		saving( next?: boolean ): boolean
		sidebar_showed( ): boolean
	}
	
}

//# sourceMappingURL=source.view.tree.d.ts.map